import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { GearSix, Plus } from "@phosphor-icons/react";

const TypeRow = ({ t, onSaved }) => {
  const [f, setF] = useState({ label: t.label, mandatory: t.mandatory, active: t.active !== false, designations: (t.designations || []).join(", ") });
  const save = async () => {
    try {
      await api.patch(`/hr/doc-types/${t.id}`, { ...f, designations: f.designations.split(",") });
      toast.success("Saved"); onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const del = async () => {
    if (!window.confirm(`Delete document type "${t.label}"?`)) return;
    try { await api.delete(`/hr/doc-types/${t.id}`); toast.success("Deleted"); onSaved(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <tr data-testid={`hr-doctype-${t.key}`}>
      <td><Input className="h-8" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} /></td>
      <td className="text-center"><input type="checkbox" checked={f.mandatory} onChange={(e) => setF({ ...f, mandatory: e.target.checked })} data-testid={`hr-doctype-mandatory-${t.key}`} /></td>
      <td className="text-center"><input type="checkbox" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} /></td>
      <td><Input className="h-8" placeholder="All designations" value={f.designations} onChange={(e) => setF({ ...f, designations: e.target.value })} /></td>
      <td className="whitespace-nowrap">
        <Button size="sm" variant="outline" className="h-8" onClick={save} data-testid={`hr-doctype-save-${t.key}`}>Save</Button>
        <Button size="sm" variant="ghost" className="h-8 text-destructive" onClick={del} data-testid={`hr-doctype-delete-${t.key}`}>Delete</Button>
      </td>
    </tr>
  );
};

export const DocTypesDialog = ({ onSaved }) => {
  const [open, setOpen] = useState(false);
  const [types, setTypes] = useState([]);
  const load = async () => { try { setTypes((await api.get("/hr/doc-types")).data); } catch (e) { toast.error(formatApiError(e)); } };
  useEffect(() => { if (open) { load(); } }, [open]);
  const add = async () => {
    const label = window.prompt("New document name");
    if (!label?.trim()) return;
    try { await api.post("/hr/doc-types", { label, mandatory: false, designations: [] }); load(); onSaved(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <>
      <Button variant="outline" className="h-9" onClick={() => setOpen(true)} data-testid="hr-doctypes-open">
        <GearSix size={14} className="mr-1.5" /> Document Settings
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl" data-testid="hr-doctypes-dialog">
          <DialogHeader>
            <DialogTitle>Required Employee Documents</DialogTitle>
            <DialogDescription>Choose which documents are mandatory or optional. Leave designations blank to apply to everyone, or list them comma-separated.</DialogDescription>
          </DialogHeader>
          <div className="max-h-[60vh] overflow-y-auto">
            <table className="data-table">
              <thead><tr><th>Document</th><th>Mandatory</th><th>Active</th><th>Only for designations</th><th></th></tr></thead>
              <tbody>{types.map((t) => <TypeRow key={t.id} t={t} onSaved={() => { load(); onSaved(); }} />)}</tbody>
            </table>
          </div>
          <Button variant="outline" className="h-9 w-fit" onClick={add} data-testid="hr-doctype-add"><Plus size={13} className="mr-1.5" /> Add Document Type</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
